import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { MWCDocumentsData } from 'src/app/core/services/cypto/crypto-docs-response.dto';

@Component({
  selector: 'pgh-coverage-docs-modal-component', 
  templateUrl: './coverage-docs-modal-component.component.html',
  styleUrl: './coverage-docs-modal-component.component.scss'
})
export class CoverageDocsModalComponent {
  docsArr : MWCDocumentsData[] = [];
  constructor(
    public dialogRef: MatDialogRef<CoverageDocsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private resourceService: ADPResourceService,
  ) { }
ngOnInit() {
    this.docsArr = this.modalData.docsArr;
  }
 
onClose(value: string) {
    this.dialogRef.close();
  }
}
